module.exports = __webpack_public_path__ + "static/media/optigrill.fe9bc9ec.png";